import { IFrameworkBaseEnitity } from "./framework-base-entity.interface";

export enum LOCATION_VISIT_STATUS {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

export interface ILocationVisit extends IFrameworkBaseEnitity {
  date?: string; // Date in YYYY-MM-DD format
  locationId?: number;
  status?: LOCATION_VISIT_STATUS;
  goaStatus?: LOCATION_VISIT_STATUS
  trkStatus?: LOCATION_VISIT_STATUS
  ctmStatus?: LOCATION_VISIT_STATUS
  atmStatus?: LOCATION_VISIT_STATUS
  percentComplete?: number;
}
